import React, { useEffect } from 'react';
import { useFlow } from 'hooks';
import FlowTableHeader from './flowTableHeader';
import FlowTableRow from './flowTableRow';

function Flow() {
	const { items, handleGet } = useFlow();

	useEffect(() => {
		handleGet();
	}, []);

	return (
		<main className="max-w-7xl mx-auto px-4 py-6">
			<h1 className="text-2xl font-bold text-gray-900 mb-6">Flow</h1>

			<div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
				<table className="w-full text-sm">
					<FlowTableHeader />
					<tbody className="divide-y divide-gray-100">
						{items &&
							items.map((item) => <FlowTableRow item={item} key={item.id} />)}
					</tbody>
				</table>
			</div>
		</main>
	);
}

export default Flow;
